// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YrZc","newExpiryDate":"styles_newExpiryDate__3gKcj","footer":"styles_footer__1povF"};